import { useRef, useState } from "react";
import { makeStyles, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, useMediaQuery } from "@material-ui/core";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

const useStyles = makeStyles(() => ({
    paper: {
        backgroundColor: "#1F2A37",
        borderRadius: 8,
        margin: "6px 0px 0px 6px",
        boxShadow: "none !important",
    },
    expertsPaper: {
        minWidth: 180,
        backgroundColor: "#111928",
        borderRadius: 6,
        border: "1px solid #374151",
        paddingBlock: 2,
        boxShadow: "none !important",
    },
    agentPaper: {
        minWidth: 210,
        backgroundColor: "#111928",
        borderRadius: 8,
        border: "1px solid #374151",
        paddingBlock: 8,
        boxShadow: "none !important",
    },
    leadPaper: {
        minWidth: 160,
        backgroundColor: "#111928",
        border: "1px solid #374151",
        borderRadius: 6,
        margin: "6px 0px 0px 6px",
        boxShadow: "0px 0px 20px 0px rgba(5, 9, 15, 0.5) !important",
    },
    menuItem: {
        color: "#D1D5DB",

        "&:is(:hover, :active, :focus)": {
            color: "#fff",
        },
    },
    expertsMenuItem: {
        display: "flex",
        gap: 8,

        "&:is(:hover, :active, :focus)": {
            background: "transparent",
        },
    },
    agentMenuItem: {
        "&:is(:hover, :active, :focus)": {
            background: "transparent",
        },

        "&:first-child": {
            padding: "0px 24px 16px",
            borderBottom: "1px solid #374151",
        },

        "&:not(:first-child):not(:last-child)": {
            padding: "16px 24px",
            border: 0,
        },

        "&:last-child": {
            padding: "16px 24px 0px",
            borderTop: "1px solid #374151",
        },
    },
    leadsMenuItem: {
        padding: 16,
        gap: 8,

        "&:is(:hover, :active, :focus)": {
            background: "#374151",
        },

        "&:first-child": {
            borderBottom: "1px solid #374151",
        },

        "&:not(:first-child):not(:last-child)": {
            border: 0,
        },

        "&:last-child": {
            borderTop: "1px solid #374151",
        },
    },
}));

const CustomMenuButton = ({ children, style, className, items = [{ label: "label", onClick: () => {}, disabled: false }], handleMenu, variant, disabled, placement }) => {
    const classes = useStyles();
    const isMobileScreen = useMediaQuery("(max-width: 576px)");
    const [open, setOpen] = useState(false);
    const anchorRef = useRef();

    const handleToggle = (event) => {
        event.stopPropagation();

        setOpen((prevOpen) => {
            if (handleMenu) handleMenu(!prevOpen);
            return !prevOpen;
        });
    };

    const handleClose = (event) => {
        if (anchorRef.current?.contains(event.target)) {
            return;
        }

        setOpen(false);
        if (handleMenu) handleMenu(false);
    };

    function handleListKeyDown(event) {
        event.stopPropagation();

        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
            if (handleMenu) handleMenu(false);
        }
    }

    return (
        <>
            <button disabled={disabled} ref={anchorRef} type="button" className={`${className ?? ""}${open ? " active" : ""}`} style={style} onClick={handleToggle}>
                {children} {variant === "assistentes" ? open ? <RiArrowDownSLine size={24} color="#FFF" /> : <RiArrowUpSLine size={24} color="#FFF" /> : null}
            </button>

            <Popper open={open} anchorEl={anchorRef.current} transition placement={placement ?? (isMobileScreen ? "bottom-center" : "bottom-start")} style={{ marginTop: variant === "assistentes" ? 8 : undefined }}>
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <Paper className={variant === "experts" ? classes.expertsPaper : variant === "assistentes" ? classes.agentPaper : variant === "leads" ? classes.leadPaper : classes.paper}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown} className={variant === "leads" ? "p-0" : ""}>
                                    {items.map((item, idx) => (
                                        <MenuItem key={`mntb-${idx}`} disabled={item.disabled} onClick={item.onClick} className={variant === "experts" ? classes.expertsMenuItem : variant === "assistentes" ? classes.agentMenuItem : variant === "leads" ? classes.leadsMenuItem : classes.menuItem}>
                                            {item.icon}

                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default CustomMenuButton;
